import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=517d88a3&"
import script from "./NavigationFooter.vue?vue&type=script&lang=js&"
export * from "./NavigationFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports